import React from 'react';
import Image from 'next/image';
import { imageTransform } from '@/shared/utils/utils';
import { SpotlightItemProps } from '@/shared/constants/pricing';
import { useConfigProvider } from '@/lib/context';
import Link from 'next/link';
import './item.less';

interface IProps {
  spotlightItems: SpotlightItemProps[];
  textColor: string;
  showItems?: boolean;
  isBuilderIOPage?: boolean;
}

export default function SpotlightHeroItem({ spotlightItems, textColor, showItems, isBuilderIOPage }: IProps) {
  const { isMobile } = useConfigProvider();
  return isBuilderIOPage ? (
    <div
      className="spotlight-items-with-builderio"
      style={showItems && isMobile ? { display: 'flex', flexFlow: 'column' } : {}}
    >
      {spotlightItems.map((item) => (
        <Link key={item.title} className="spotlight-items-item" href="/sell-on-pietra/register">
          <Image
            width={250}
            height={250}
            src={item.image}
            priority
            sizes="(min-width: 1240px) 286px, ((min-width: 1024px) and (max-width:1240px)) calc(25vw - 23px), ((min-width: 300px) and (max-width:1024px)) calc(50vw - 16px), calc(50vw - 16px)"
            alt={item.title}
            className="spotlight-image"
          />
          <p className="spotlight-title" style={{ color: textColor }}>
            {item.title}
          </p>
        </Link>
      ))}
    </div>
  ) : (
    <div className="spotlight-items" style={showItems && isMobile ? { display: 'flex', flexFlow: 'column' } : {}}>
      {spotlightItems.map((item) => (
        <div key={item.title} className="spotlight-items-item">
          <Image
            width={250}
            height={250}
            sizes="auto, (max-width: 767.99px) 0px, (min-width: 768px) 150px, (min-width: 1024px) 180px, (min-width: 1280px) 211px, 0"
            src={imageTransform(item.image, 'large')}
            alt={item.title}
            className="spotlight-image"
          />
          <h3 className="spotlight-title" style={{ color: textColor }}>
            {item.title}
          </h3>
          <p className="spotlight-desc" style={{ color: textColor }}>
            {item.description}
          </p>
        </div>
      ))}
    </div>
  );
}
